/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-use-before-define */
/* global $ */
import cleanPasteHTML from '~/util/cleanPasteHTML'
import { flatten } from 'ramda'
import template from './template.html'

export default [directive]

function directive($compile, contentTemplatesService) {
  return {
    require: '^composeBody',
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      feature: '=',
    },
    controller: [Controller],
    link: Link,
  }
}

function Link(scope, elem, attrs, controller) {
  controller.registerPropertyValidator('quote', scope.vm.isValid)
  scope.vm.composeBodyController = controller
}

function Controller() {
  this.appendBlock = () =>
    this.feature.content_elements.push({ type: 'text', content: '' })

  this.canShowDelete = () =>
    this.feature.content_elements && this.feature.content_elements.length > 1

  this.removeBlock = ($event) => {
    $event.preventDefault()
    if (this.feature.content_elements) {
      const {
        currentTarget: {
          dataset: { index },
        },
      } = $event
      this.feature.content_elements.splice(parseInt(index, 10), 1)
    }
  }

  this.$onDestroy = () => {
    this.composeBodyController &&
      this.composeBodyController.registerPropertyValidator('quote', null)
  }

  const processText = (textOrHTML) => {
    const temp$ = $(`<div>${textOrHTML}</div>`)
    cleanPasteHTML(temp$)
    return temp$.text()
  }

  const splitNewLines = (contentElements) =>
    contentElements.map((el) =>
      el.content
        .split('\n')
        .map((content) => Object.assign({}, el, { content }))
    )

  const processElementText = (contentElements) =>
    contentElements.map((el) =>
      Object.assign(el, { content: processText(el.content) })
    )

  const getNonemptyElements = (contentElements) =>
    contentElements.filter((el) => el.content && el.content.length > 0)

  const isContentElementsValid = (contentElements) =>
    Array.isArray(contentElements) && contentElements.length > 0

  this.isValid = (feature) => {
    const contentElements = getNonemptyElements(
      processElementText(flatten(splitNewLines(this.feature.content_elements)))
    )

    if (!isContentElementsValid(contentElements)) {
      return false
    }

    this.feature.content_elements = contentElements
    return true
  }
}
